/**
 * Runtime configuration injected by nginx via /config.js.
 * Falls back to env vars for local dev server usage.
 */

declare global {
  interface Window {
    __CONFIG?: {
      googleClientId?: string;
      appleClientId?: string;
    };
  }
}

const DEFAULT_GOOGLE_CLIENT_ID = '741273044106-h5a1civdk4vbj0un9gm32burtlgl1plg.apps.googleusercontent.com';
const DEFAULT_APPLE_CLIENT_ID = 'com.yanicksenn.telemetry.service';

export function getGoogleClientId(): string {
  return window.__CONFIG?.googleClientId || (import.meta as any).env?.VITE_GOOGLE_CLIENT_ID || DEFAULT_GOOGLE_CLIENT_ID;
}

export function getAppleClientId(): string {
  return window.__CONFIG?.appleClientId || (import.meta as any).env?.VITE_APPLE_CLIENT_ID || DEFAULT_APPLE_CLIENT_ID;
}
